/**
 * 区域管理
 */
<template>
  <div>
    <div style="margin: 20px">
      <div v-show="See">
        <div @click="close()">
          <img class="close" src="../../assets/img/close.png" />
        </div>
      </div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>运营统计</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <div v-if="show">
        <el-form :inline="true" :model="formInline" style="margin-top: 20px; heigth: 60px">
          <el-form-item label="开始时间:">
            <div class="block">
              <el-date-picker size="small" v-model="formInline.startDate" value-format="yyyy-MM-dd" type="date"
                placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="结束时间:">
            <div class="block">
              <el-date-picker size="small" v-model="formInline.endDate" value-format="yyyy-MM-dd" type="date"
                placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="区域名称:">
            <el-cascader v-model="region" size="small " :options="options" :props="{ checkStrictly: true }"
              style="width: 300px" clearable></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="exportArea()">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--列表-->
      <div v-if="display" style="margin-top: 20px">
        <div v-if="exportbtn" style="
                      margin-right: 20px;
                      position: absolute;
                      top: 15%;
                      right: 2%;
                      z-index: 1;
                    ">
          <el-button size="small" type="primary" @click="exportArea()"
            v-if="check_auth('/web/projectOperatingLog/export_all')">导出</el-button>
        </div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="区域统计" name="first" v-if="areaShow">
            <el-table :data="listData" border element-loading-text="拼命加载中" style="width: 100%">
              <el-table-column align="center" label-aligin="center" prop="id" label="ID" width="80"></el-table-column>
              <el-table-column align="center" label-aligin="center" prop="area" min-width="140" label="区域名称">
              </el-table-column>

              <el-table-column align="center" label-aligin="center" prop="total_mileage_str" min-width="140" label="运行里程">
              </el-table-column>
              <el-table-column align="center" label-aligin="center" prop="total_time_str" min-width="200" label="运行时间">
              </el-table-column>
              <el-table-column align="center" label-aligin="center" prop="auto_drive_mileage_str" min-width="140"
                label="自动驾驶里程"></el-table-column>
              <el-table-column align="center" label-aligin="center" prop="auto_drive_time_str" min-width="200"
                label="自动驾驶时间"></el-table-column>
              <el-table-column align="center" label-aligin="center" prop="drive_mileage_str" min-width="140"
                label="人工驾驶里程">
              </el-table-column>
            <el-table-column align="center" label-aligin="center" prop="drive_time_str" min-width="200" label="人工驾驶时间">
              </el-table-column>
              <!-- <el-table-column align="center" label-aligin="center" prop="operation_days" label="运行天数" min-width="200">
                        </el-table-column> -->
              <el-table-column align="center" label-aligin="center" label="操作" width="120">
                <template slot-scope="scope">
                  <el-button round size="mini" type="warning" :disabled="onShow" @click="regionDate(scope.row)">详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        <el-tab-pane v-for="item in carType" :key="item.value" :label="item.label" :name="item.value">
          <el-table :data="carList" border element-loading-text="拼命加载中" style="width: 100%">
            <!-- <el-table-column
                align="center"
                label-aligin="center"
                prop="id"
                          label="ID"
                          width="80"
                        ></el-table-column> -->
              <el-table-column align="center" label-aligin="center" prop="vin" min-width="200" label="车辆编号">
              </el-table-column>

              <el-table-column align="center" label-aligin="center" prop="total_mileage_str" min-width="150" label="运行里程">
              </el-table-column>
              <el-table-column align="center" label-aligin="center" prop="total_time_str" min-width="200" label="运行时间">
              </el-table-column>
              <el-table-column align="center" label-aligin="center" prop="auto_drive_mileage_str" min-width="150"
                label="自动驾驶里程"></el-table-column>
              <el-table-column align="center" label-aligin="center" prop="auto_drive_time_str" min-width="200"
                label="自动驾驶时间"></el-table-column>
              <el-table-column align="center" label-aligin="center" prop="drive_mileage_str" min-width="150"
                label="人工驾驶里程">
              </el-table-column>
              <el-table-column align="center" label-aligin="center" prop="drive_time_str" label="人工驾驶时间" min-width="250">
              </el-table-column>
              <el-table-column align="center" label-aligin="center" prop="current_day_online_state" label="运行天数"
                min-width="200">
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {
  get_projectOperatingLog_list,
  get_operatingLog_list,
  get_projectOperatingLog_carType,
  get_operatingLog_one_list,
  // get_exportArea_list,
  // get_carTypeExport_list,
  get_carTypeExport_all_list,
} from "../../api/projectLog/operationLog";
import {
  auth
} from "../../utils/util";
export default {
  data() {
    return {
      display: false,
      show: true,
      See: false,
      onShow: true,
      areaShow: true,
      exportbtn: false,
      activeName: "first",
      loading: false, //是显示加载
      region: [],
      options: [],
      carType: [],
      value: [],
      // rules表单验证
      rules: {
        name: [{ required: true, message: "请输入区域名称", trigger: "blur" }],
        line_count: [
          { required: true, message: "请输入区域编号", trigger: "blur" },
        ],
      },
      formInline: {
        startDate: "",
        endDate: "",
        groupId: "",
      },
      listData: [],
      carList: [],
    };
  },
  // 注册组件

  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    var day1 = new Date();
    day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
    let start =
      day1.getFullYear() +
      "-" +
      (day1.getMonth() + 1 < 10
        ? "0" + (day1.getMonth() + 1)
        : day1.getMonth() + 1) +
      "-" +
      (day1.getDate() < 10 ? "0" + day1.getDate() : day1.getDate());
    this.formInline.startDate = start;
    this.formInline.endDate = start;
    this.getRegionList();
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取区域列表
    getRegionList() {
      get_projectOperatingLog_list().then((res) => {
        if (res["code"] === 0) {
          this.options = res.data;
        }
      });
    },
    check_auth(val) {
      return auth(val);
    },
    // 区域信息
    getData() {
      this.activeName = "first";
      get_operatingLog_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.listData = res.data;
          for (let i = 0; i < this.listData.length; i++) {
            if (this.listData[i].total_mileage_str === null) {
              this.listData[i].total_mileage_str = "0.0公里";
            }
            if (this.listData[i].total_time_str === null) {
              this.listData[i].total_time_str = "00小时00分00秒";
            }
            if (this.listData[i].auto_drive_mileage_str === null) {
              this.listData[i].auto_drive_mileage_str = "0.0公里";
            }
            if (this.listData[i].auto_drive_time_str === null) {
              this.listData[i].auto_drive_time_str = "00小时00分00秒";
            }
            if (this.listData[i].drive_mileage_str === null) {
              this.listData[i].drive_mileage_str = "0.0公里";
            }
            if (this.listData[i].drive_time_str === null) {
              this.listData[i].drive_time_str = "00小时00分00秒";
            }
          }
          this.getCarTypeOne();
        }
      });
    },
    getCarType() {
      get_projectOperatingLog_carType(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.carType = res.data;
          if (!this.areaShow) {
            if (this.carType.length > 0) {
              this.activeName = this.carType[0].value;
            }
          }
        }
      });
    },
    getFor(id, shuzu) {
      shuzu.forEach((item) => {
        if (id == item.value) {
          if (item.children == null) {
            this.getCarType();
            this.areaShow = false;
            this.onShow = true;
            setTimeout(() => {
              if (this.carType.length > 0) {
                this.getCarTypeOne();
              }
            }, 1000);
          } else {
            this.onShow = false;
            this.areaShow = true;
            this.getData();
            this.getCarType();
          }
        } else if (item.children != null) {
          this.getFor(id, item.children);
        }
      });
    },
    // 搜索事件
    search() {
      if (this.region) {
        this.formInline.groupId = this.region[this.region.length - 1];
      }
      if (
        this.formInline.startDate !== "" &&
        this.formInline.endDate !== "" &&
        this.region.length > 0
      ) {
        this.display = true;
        this.getFor(this.formInline.groupId, this.options);
      } else {
        this.display = false;
        this.$message.error("请选择时间段和区域");
      }
    },
    // 跳转任务管理界面
    getCarTypeOne() {
      get_operatingLog_one_list(this.formInline, this.activeName).then(
        (res) => {
          if (res["code"] === 0) {
            this.carList = res.data;
          }
        }
      );
    },
    regionDate(row) {
      this.value.push(this.formInline.groupId);
      this.formInline.groupId = row.id;
      this.getFor(this.formInline.groupId, this.options);
      this.show = false;
      this.See = true;
      this.exportbtn = true;
    },
    close() {
      this.show = true;
      this.See = false;
      this.exportbtn = false;
      this.formInline.groupId = this.value[this.value.length - 1];
      this.getFor(this.formInline.groupId, this.options);
      this.getCarTypeOne();
    },
    handleClick() {
      if (this.activeName == "first") {
        this.getData();
      }
      this.getCarTypeOne();
    },
    // getExport() {
    //   get_exportArea_list(this.formInline)
    //     .then((res) => {
    //       if (res["code"] == undefined) {
    //         // 这里根据后端返回使用res或res.data
    //         var blob = new Blob([res], {
    //           type: "application/ms-excel",
    //         });
    //         var elink = document.createElement("a");
    //         elink.download = "区域统计" + ".xlsx";
    //         elink.href = URL.createObjectURL(blob);
    //         document.body.appendChild(elink);
    //         elink.click(); //点击下载
    //         document.body.removeChild(elink); //下载完成移除元素
    //         window.URL.revokeObjectURL(elink); //释放掉blob对象
    //       }
    //     })
    //     .catch((err) => {
    //       this.$notify.error({
    //         title: "提示",
    //         message: err.message,
    //       });
    //     });
    // },
    getExport() {
      this.formInline.groupId = this.region[this.region.length - 1];
      get_carTypeExport_all_list(this.formInline)
        .then((res) => {
          if (res["code"] == undefined) {
            // 这里根据后端返回使用res或res.data
            var blob = new Blob([res], {
              type: "application/ms-excel",
            });
            var elink = document.createElement("a");
            elink.download = "区域统计" + ".xlsx";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click(); //点击下载
            document.body.removeChild(elink); //下载完成移除元素
            window.URL.revokeObjectURL(elink); //释放掉blob对象
          }
        })
        .catch((err) => {
          this.$notify.error({
            title: "提示",
            message: err.message,
          });
        });
    },
    getExportType() {
      get_carTypeExport_list(this.formInline, this.activeName)
        .then((res) => {
          if (res["code"] == undefined) {
            // 这里根据后端返回使用res或res.data
            var blob = new Blob([res], {
              type: "application/ms-excel",
            });
            var elink = document.createElement("a");
            elink.download = this.activeName + ".xlsx";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click(); //点击下载
            document.body.removeChild(elink); //下载完成移除元素
            window.URL.revokeObjectURL(elink); //释放掉blob对象
          }
        })
        .catch((err) => {
          this.$notify.error({
            title: "提示",
            message: err.message,
          });
        });
    },
    exportArea() {
      if (
        this.formInline.startDate !== "" &&
        this.formInline.endDate !== "" &&
        this.region.length > 0
      ) {
        // if (this.activeName == "first") {
        //   this.getExport();
        // } else {
        //   this.getExportType();
        // }
        this.getExport();
      } else {
        this.$message.error("下载失败");
      }
    },
  },
};
</script>

<style scoped>
.close {
  width: 1.5%;
  height: 2.5%;
  position: absolute;
  top: 8%;
  left: 97%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/car_operate/car_operate.vue